// Screen reader announcement for product cards on Enter key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Enter' || event.keyCode === 13) {
    const card = event.target.closest('.card-wrapper.product-card-wrapper');
    if (!card) return;
 
    // Do not trigger if focus is on quick shop buttons
    if (event.target.closest('.quick-add')) return;
 
    const productName = card.getAttribute('data-product-title');
    if (productName) {
      let announcer = document.getElementById('sr-card-desc-announcer');
      if (!announcer) {
        announcer = document.createElement('div');
        announcer.id = 'sr-card-desc-announcer';
        announcer.setAttribute('aria-live', 'assertive');
        announcer.style.position = 'absolute';
        announcer.style.left = '-9999px';
        announcer.style.width = '1px';
        announcer.style.height = '1px';
        announcer.style.overflow = 'hidden';
        document.body.appendChild(announcer);
      }
     
      // Clear first to allow repeating, then update text
      announcer.textContent = '';
      setTimeout(() => {
        announcer.textContent = 'View details for ' + productName;
      }, 50);
    }
 
  }
});

// Ensure certain boost-sd elements are keyboard-focusable (for third-party injected markup)
(function() {
  function setTabindex() {
    var els = document.querySelectorAll('.boost-sd__breadcrumb-link--no-hover, .boost-sd__header-title, .boost-sd__product-label, .boost-sd__format-currency');
    els.forEach(function(el) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    });
  }

  function fixBoostProductCount() {
    var els = document.querySelectorAll('.boost-sd__product-count, .boost-sd__toolbar-item--product-count, .boost-sd__toolbar-item');
    els.forEach(function(el) {
      ['role', 'aria-live', 'aria-atomic'].forEach(function(attr) {
        if (el.hasAttribute(attr)) {
          el.removeAttribute(attr);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTabindex();
      fixBoostProductCount();
    });
  } else {
    setTabindex();
    fixBoostProductCount();
  }

  var observer = new MutationObserver(function() {
    setTabindex();
    fixBoostProductCount();
  });
  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
})();

// Header Dropdown Menu Keyboard Navigation & Accessibility Fix
(function () {
  function getDropdownName(summary) {
    if (!summary) return '';
    var span = summary.querySelector('span');
    var rawText = span ? span.textContent : summary.textContent;
    return (rawText || '').replace(/\s+/g, ' ').trim();
  }

  function getFocusableElements(container) {
    if (!container) return [];
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var elements = Array.prototype.slice.call(container.querySelectorAll(selector));
    return elements.filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }

  function getNextFocusableElement(currentDetails) {
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var all = Array.prototype.slice.call(document.querySelectorAll(selector)).filter(function (el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });

    var lastInDetailsIndex = -1;
    for (var i = 0; i < all.length; i++) {
      if (currentDetails.contains(all[i])) {
        lastInDetailsIndex = i;
      }
    }

    if (lastInDetailsIndex !== -1 && lastInDetailsIndex < all.length - 1) {
      return all[lastInDetailsIndex + 1];
    }
    return null;
  }

  // Set aria-expanded and aria-label attributes on header details elements
  function initHeaderMenuAccessibility() {
    var detailsList = document.querySelectorAll('header-menu details, details.mega-menu, details.Details-HeaderMenu');
    detailsList.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;

      var isOpen = details.hasAttribute('open');
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      var content = details.querySelector('.mega-menu__content, .header__submenu');
      if (content && content.id) {
        summary.setAttribute('aria-controls', content.id);
      }

      var dropdownName = getDropdownName(summary);
      if (dropdownName) {
        summary.setAttribute('aria-label', dropdownName + ' dropdown menu press tab to open');
      }

      // Ensure mega nav images have accessible alt text if focused
      details.querySelectorAll('.mega-nav-image').forEach(function (img) {
        if (!img.getAttribute('alt')) {
          img.setAttribute('alt', dropdownName ? dropdownName + ' featured banner' : 'Featured banner');
        }
      });
    });
  }

  // Handle Tab, Shift+Tab, and Escape key navigation
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' && e.key !== 'Escape' && e.key !== 'Esc') return;

    var active = document.activeElement;
    if (!active) return;

    // Case A: User is on <summary> and presses Tab (Forward)
    if (e.key === 'Tab' && !e.shiftKey) {
      var summary = active.closest('header-menu details summary, details.mega-menu summary, details.Details-HeaderMenu summary');
      if (summary) {
        var details = summary.closest('details');
        if (details) {
          var content = details.querySelector('.mega-menu__content, .header__submenu');
          if (content) {
            var focusables = getFocusableElements(content);
            if (focusables.length > 0) {
              e.preventDefault();
              if (!details.hasAttribute('open')) {
                details.setAttribute('open', '');
                summary.setAttribute('aria-expanded', 'true');
              }
              focusables[0].focus();
              return;
            }
          }
        }
      }
    }

    // Case B: User is INSIDE the dropdown content and presses Tab or Shift+Tab
    var details = active.closest('header-menu details, details.mega-menu, details.Details-HeaderMenu');
    if (details && details.hasAttribute('open')) {
      var summary = details.querySelector('summary');
      var content = details.querySelector('.mega-menu__content, .header__submenu');

      if (e.key === 'Escape' || e.key === 'Esc') {
        if (summary) {
          e.preventDefault();
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
          return;
        }
      }

      if (content && content.contains(active)) {
        var focusables = getFocusableElements(content);
        if (focusables.length > 0) {
          var firstItem = focusables[0];
          var lastItem = focusables[focusables.length - 1];

          // Shift + Tab on FIRST dropdown item -> Move focus back to summary
          if (e.shiftKey && e.key === 'Tab' && active === firstItem) {
            e.preventDefault();
            summary.focus();
            return;
          }

          // Tab on LAST dropdown item -> Close dropdown & move focus to NEXT main menu item
          if (!e.shiftKey && e.key === 'Tab' && active === lastItem) {
            e.preventDefault();
            details.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');

            var nextEl = getNextFocusableElement(details);
            if (nextEl) {
              nextEl.focus();
            }
            return;
          }
        }
      }
    }
  });

  // Sync aria-expanded state when details toggle
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (details && details.matches && details.matches('header-menu details, details.mega-menu, details.Details-HeaderMenu')) {
      var summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', details.hasAttribute('open') ? 'true' : 'false');
      }
    }
  }, true);

  // Initialize on load
  document.addEventListener('DOMContentLoaded', initHeaderMenuAccessibility);
  window.addEventListener('load', initHeaderMenuAccessibility);

  var observer = new MutationObserver(initHeaderMenuAccessibility);
  observer.observe(document.body, { childList: true, subtree: true });
})();
